import { ErrorInfo } from 'react';

const UNKNOWN_ERROR = 'Unknown error';

export class ErrorUtils {
  public constructor(private readonly error: Error, private readonly errorInfo?: ErrorInfo) {}

  private getErrorMessage(error: Error) {
    if (!error || error.message === '') {
      return UNKNOWN_ERROR;
    }

    if (error.message) {
      return error.message;
    }

    try {
      return JSON.stringify(error);
    } catch (e) {
      return 'Error: Unstringifiable error object';
    }
  }

  private getShortMessage(errorMessage: string) {
    if (!errorMessage) {
      return UNKNOWN_ERROR;
    }

    const lines = errorMessage.split('\n');
    if (!lines.length) {
      return 'Empty error message';
    }

    const firstLine = lines[0] || '';
    return firstLine.slice(0, 150);
  }

  public generateErrorTitle() {
    const parts: string[] = [];
    const error = this.error;

    if (error.name !== 'Error') {
      parts.push(error.name);
    }

    if (this.errorInfo?.componentStack) {
      try {
        // Extract the first non-empty component line from stack trace
        const stackLines = this.errorInfo.componentStack.split('\n');
        if (stackLines.length > 1) {
          // Component names in React stack traces follow format: "in ComponentName (at file.js:line:col)"
          const componentLine = stackLines[1].trim();
          const componentMatch = componentLine.match(/^in\s+([^\s]+)/);
          const componentName = componentMatch?.[1];
          if (componentName) {
            parts.push(`[${componentName}]`);
          }
        }
      } catch (err) {
        console.warn('Failed to parse component stack:', err);
      }
    }

    const errorMessage = this.getErrorMessage(error);
    const shortMessage = this.getShortMessage(errorMessage);
    parts.push(shortMessage);

    return parts.join(' ').trim();
  }
}
